import { useT } from "../../i18n";
import Layout from "../../components/Layout";
import { Paper, Typography } from "@mui/material";
import AnwesenheitenDataTable from "../../components/anwesenheiten/AnwesenheitenDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function Anwesenheiten() {
  const { t } = useT("taetigkeitsbericht");
  const limit = parseInt(
    localStorage.getItem("anwesenheitenLimit") ?? "25",
    10
  );
  return (
    <Layout title="Anwesenheiten" showTitleInNav={false}>
      <Guard
        permission={"anwesenheit:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Anwesenheiten</Typography>
          <AnwesenheitenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
